import "./EditableEntries.css";
import EditableCardEntryInput from "./EditableCardEntryInput";

export function displayPhoneNumber(phone_number: string | number | null | undefined): string | number | null | undefined {
    if (!phone_number)
        return phone_number;

    const digits = cleanPhoneNumber(phone_number);

    if (digits.length === 10) {
        return `(${digits.slice(0, 3)})-${digits.slice(3, 6)}-${digits.slice(6)}`;
    } else if (digits.length === 11 && digits[0] === '1') {
        return `+1 (${digits.slice(1, 4)})-${digits.slice(4, 7)}-${digits.slice(7)}`;
    }

    return phone_number;
}

export function cleanPhoneNumber(phone_number: string | number | null | undefined): string {
    return (phone_number as string)?.replace(/\D/g, '') ?? '';
}

const EditableCardEntryPhone = ({baseValue, onEdit, isEditing, displayLabel, hyperlinkDisplay}: {
    baseValue: string | number | null | undefined;
    onEdit?: (value: string) => void;
    isEditing?: boolean;
    displayLabel?: string;
    hyperlinkDisplay?: boolean;
}) => (
    <EditableCardEntryInput type={"tel"} onEdit={(v) => {
        onEdit(cleanPhoneNumber(v));
    }} isEditing={isEditing} displayLabel={displayLabel} displayValue={hyperlinkDisplay && baseValue ? <a href={`tel:${cleanPhoneNumber(baseValue as string)}`}>{displayPhoneNumber(baseValue as string)}</a> : displayPhoneNumber(baseValue)} baseValue={baseValue} />
)

export default EditableCardEntryPhone;
